import React from 'react';
import Screen from '../../../Screen';
import ListItem from '../../../../elements/DEPRECATED_ListItem';
import Link from '../../../../elements/Link';
import Header from './Header';
import eventHumanFriendlyDate from '../../../../../misc/eventHumanFriendlyDate';
import Scrollable from '../../../../elements/Scrollable';

export default class SelectEventScreen extends React.Component {
    render() {
        let {i18n, events} = this.props;

        return <Screen header={<Header {
                ...this.props
            } />}>
            <Scrollable>
                {
                    events.map(event => {
                        let date = eventHumanFriendlyDate(event, event.start_local, event.end_local);
                        return <Link href={'./' + event.id} key={event.id}>
                            <ListItem icon={event.icon_url} tagName="div" next="next">
                                <p className="text main">{event.name}</p>
                                {
                                    event._isEvent
                                        ? <p className="text">{date}</p>
                                        : null
                                }
                            </ListItem>
                        </Link>
                    })
                }
            </Scrollable>
        </Screen>;
    }
}
